import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import { WORKOUT_EXERCISE_KEY } from '../../constants'

function getSetDataWorkoutExerciseUtil (instance) {
  return getValueReduxUtil(
    instance,
    WORKOUT_EXERCISE_KEY.SET_DATA
  ) || []
}

export {
  getSetDataWorkoutExerciseUtil
}
